__turbopack_context__.v({
  "navigationListItem": "hOAP-q_navigationListItem",
  "navigationListItem--lgUp": "hOAP-q_navigationListItem--lgUp",
  "navigationListItem--mdDown": "hOAP-q_navigationListItem--mdDown",
  "navigationListItem--mdUp": "hOAP-q_navigationListItem--mdUp",
  "navigationListItem--smUp": "hOAP-q_navigationListItem--smUp",
});
